import { getHeaderNavLinks } from './navLinks';
var nav = ['Inicio', 'Herramientas de estudio', 'Publicar una pregunta', 'Resolver problemas matemáticos', 'Visita el centro de redacción'];
var secondaryNav = ['Carrera profesional'];
var userNav = ['Mi cuenta', 'Matemáticas', 'Escritura', 'Ayuda', 'Cerrar sesión'];
var lifePrimaryNav = ['Dinero', 'Salud y bienestar', 'Habilidades para la vida', 'Recursos', 'Nosotros', 'Buscar en Chegg Life', 'Busca ayuda'];
var qnaNav = ['Únete ahora', 'Resuscríbete', 'Reanuda'];
var qnaUserNav = ['Mi cuenta', 'Matemáticas', 'Escritura', 'Ayuda', 'Cerrar sesión'];
export default getHeaderNavLinks(nav, secondaryNav, userNav, lifePrimaryNav, qnaNav, qnaUserNav);